import type { Account, AccountFilters, AccountStats, CreateAccountData, UpdateAccountData } from "@/types/account";

// Mock data per accounts
const mockAccounts: Account[] = [
    {
        id: "1",
        userType: "SHIPPER",
        legalName: "TechCorp Solutions LLC",
        entityType: "LLC",
        taxId: "TC-2024-001",
        address: {
            street: "123 Business Ave",
            city: "New York",
            state: "NY",
            postalCode: "10001",
        },
        country: "United States",
        email: "contact@techcorp.com",
        phone: "+1-555-0123",
        password: "sender123",
        status: "Attivo",
        notes: "Client principale del settore tech",
        createdAt: new Date("2024-01-15"),
        updatedAt: new Date("2024-01-20"),
    },
    {
        id: "2",
        userType: "RECEIVER",
        legalName: "Global Partners Corp",
        entityType: "Corporation",
        taxId: "GP-2024-002",
        address: {
            street: "456 Corporate Blvd",
            city: "London",
            state: "England",
            postalCode: "SW1A 1AA",
        },
        country: "United Kingdom",
        email: "info@globalpartners.co.uk",
        phone: "+44-20-7946-0958",
        password: "receiver123",
        status: "Attivo",
        notes: "Partnership internazionale",
        createdAt: new Date("2024-01-10"),
        updatedAt: new Date("2024-01-18"),
    },
    {
        id: "3",
        userType: "SHIPPER",
        legalName: "Innovation Hub Partnership",
        entityType: "Partnership",
        taxId: "IH-2024-003",
        address: {
            street: "789 Innovation St",
            city: "Berlin",
            state: "Berlin",
            postalCode: "10115",
        },
        country: "Germany",
        email: "hello@innovationhub.de",
        phone: "+49-30-12345678",
        password: "sender456",
        status: "Sospeso",
        notes: "In attesa di documentazione aggiuntiva",
        createdAt: new Date("2024-01-05"),
        updatedAt: new Date("2024-01-12"),
    },
    {
        id: "4",
        userType: "RECEIVER",
        legalName: "Green Future NGO",
        entityType: "NGO",
        taxId: "GF-2024-004",
        address: {
            street: "321 Eco Street",
            city: "Amsterdam",
            state: "North Holland",
            postalCode: "1012 AB",
        },
        country: "Netherlands",
        email: "contact@greenfuture.nl",
        phone: "+31-20-1234567",
        password: "receiver456",
        status: "Attivo",
        notes: "Organizzazione no-profit per ambiente",
        createdAt: new Date("2024-01-08"),
        updatedAt: new Date("2024-01-15"),
    },
    {
        id: "5",
        userType: "SHIPPER",
        legalName: "Digital Ventures LLC",
        entityType: "LLC",
        taxId: "DV-2024-005",
        address: {
            street: "654 Startup Lane",
            city: "San Francisco",
            state: "CA",
            postalCode: "94105",
        },
        country: "United States",
        email: "team@digitalventures.com",
        phone: "+1-415-555-0199",
        password: "sender789",
        status: "Inattivo",
        notes: "Account sospeso per mancato pagamento",
        createdAt: new Date("2023-12-20"),
        updatedAt: new Date("2024-01-10"),
    },
    {
        id: "6",
        userType: "RECEIVER",
        legalName: "European Trading Co.",
        entityType: "Corporation",
        taxId: "ET-2024-006",
        address: {
            street: "987 Commerce Plaza",
            city: "Paris",
            state: "Île-de-France",
            postalCode: "75001",
        },
        country: "France",
        email: "info@europeantrading.fr",
        phone: "+33-1-42-86-83-26",
        password: "receiver789",
        status: "Attivo",
        notes: "Trading company con focus Europa",
        createdAt: new Date("2024-01-12"),
        updatedAt: new Date("2024-01-19"),
    },
    {
        id: "7",
        userType: "SHIPPER",
        legalName: "Sole Proprietor Consulting",
        entityType: "Sole Proprietorship",
        taxId: "SP-2024-007",
        address: {
            street: "147 Consultant Ave",
            city: "Toronto",
            state: "Ontario",
            postalCode: "M5H 2N2",
        },
        country: "Canada",
        email: "john@consulting.ca",
        phone: "+1-416-555-0123",
        password: "sender101",
        status: "Attivo",
        notes: "Consulente individuale specializzato",
        createdAt: new Date("2024-01-14"),
        updatedAt: new Date("2024-01-21"),
    },
    {
        id: "8",
        userType: "RECEIVER",
        legalName: "Health Foundation NGO",
        entityType: "NGO",
        taxId: "HF-2024-008",
        address: {
            street: "258 Health Blvd",
            city: "Geneva",
            state: "Geneva",
            postalCode: "1201",
        },
        country: "Switzerland",
        email: "info@healthfoundation.ch",
        phone: "+41-22-123-4567",
        password: "receiver101",
        status: "Attivo",
        notes: "Fondazione per la salute pubblica",
        createdAt: new Date("2024-01-11"),
        updatedAt: new Date("2024-01-17"),
    },
    {
        id: "admin-1",
        userType: "ADMIN",
        legalName: "Eve Admin",
        entityType: "Corporation",
        taxId: "CA-ADMIN-001",
        address: {
            street: "Admin Street 1",
            city: "Admin City",
            state: "Admin State",
            postalCode: "00000",
        },
        country: "Italy",
        email: "admin@eve-mind.com",
        phone: "+39-000-000-0000",
        password: "password123",
        status: "Attivo",
        notes: "Super Admin Account",
        createdAt: new Date("2024-01-01"),
        updatedAt: new Date("2024-01-01"),
    },
    {
        id: "ff-1",
        userType: "FREIGHT_FORWARDER",
        legalName: "Global Logistics Forwarding",
        entityType: "Corporation",
        taxId: "GLF-2024-001",
        address: {
            street: "789 Logistics Avenue",
            city: "Milan",
            state: "Lombardy",
            postalCode: "20121",
        },
        country: "Italy",
        email: "info@globallogistics.it",
        phone: "+39-02-1234-5678",
        password: "forwarder123",
        status: "Attivo",
        notes: "Freight Forwarder specializzato in trasporti internazionali",
        createdAt: new Date("2024-01-16"),
        updatedAt: new Date("2024-01-22"),
    },
];

// In-memory storage
let accounts = [...mockAccounts];

// Helper functions per CRUD operations
export const accountService = {
    // Get all accounts
    getAll: (): Account[] => {
        return [...accounts];
    },

    // Get account by ID
    getById: (id: string): Account | undefined => {
        return accounts.find((account) => account.id === id);
    },

    // Create new account
    create: (data: CreateAccountData): Account => {
        const newAccount: Account = {
            id: (accounts.length + 1).toString(),
            ...data,
            createdAt: new Date(),
            updatedAt: new Date(),
        };
        accounts.push(newAccount);
        return newAccount;
    },

    // Update account
    update: (id: string, data: UpdateAccountData): Account | null => {
        const index = accounts.findIndex((account) => account.id === id);
        if (index === -1) return null;

        accounts[index] = {
            ...accounts[index],
            ...data,
            updatedAt: new Date(),
        };
        return accounts[index];
    },

    // Delete account
    delete: (id: string): boolean => {
        const index = accounts.findIndex((account) => account.id === id);
        if (index === -1) return false;

        accounts.splice(index, 1);
        return true;
    },

    // Search and filter accounts
    search: (filters: AccountFilters): Account[] => {
        let filtered = [...accounts];

        if (filters.search) {
            const searchTerm = filters.search.toLowerCase();
            filtered = filtered.filter(
                (account) =>
                    account.legalName.toLowerCase().includes(searchTerm) ||
                    account.email.toLowerCase().includes(searchTerm) ||
                    account.taxId.toLowerCase().includes(searchTerm) ||
                    account.country.toLowerCase().includes(searchTerm),
            );
        }

        if (filters.status) {
            filtered = filtered.filter((account) => account.status === filters.status);
        }

        if (filters.entityType) {
            filtered = filtered.filter((account) => account.entityType === filters.entityType);
        }

        if (filters.country) {
            filtered = filtered.filter((account) => account.country === filters.country);
        }

        if (filters.userType) {
            filtered = filtered.filter((account) => account.userType === filters.userType);
        }

        return filtered;
    },

    // Get statistics
    getStats: (): AccountStats => {
        const now = new Date();
        const thisMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        return {
            total: accounts.length,
            active: accounts.filter((account) => account.status === "Attivo").length,
            suspended: accounts.filter((account) => account.status === "Sospeso").length,
            inactive: accounts.filter((account) => account.status === "Inattivo").length,
            newThisMonth: accounts.filter((account) => account.createdAt >= thisMonth).length,
        };
    },

    // Get recent accounts
    getRecent: (limit: number = 5): Account[] => {
        return [...accounts].sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()).slice(0, limit);
    },
};
